"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { Button } from "@/components/ui/button";

export function MiniTerminal() {
  const [copied, setCopied] = useState(false);
  const code =
    "pip install moondream-station";

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="relative flex items-center rounded-lg border border-border bg-muted/85 px-4 py-3 font-mono">
        <code className="mr-8 text-xs"><span className="select-none">$ </span>{code}</code>
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 h-8 w-8 hover:cursor-pointer"
          onClick={copyToClipboard}
          aria-label="Copy code"
        >
          {copied ? (
            <Check className="h-4 w-4 text-green-500" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </Button>
      </div>
    </div>
  );
}
